export enum RecommendationChannel {
  CATEGORY_PAGE = 'categoryPage',
  MARKETING_BOX = 'marketingBox',
  SEARCH_PAGE = 'searchPage',
  WISHLIST = 'wishList',
}
